module.exports = __webpack_public_path__ + "img/ic_hj_mode_desleep.a8764264.png";